export default "__VITE_ASSET__nFNNOMWK__"